import {useCallback} from 'react';
// import {currentCart} from '@netx/core-cart/singletons/currentCart';
import {useRpc} from '@netx/core-components/hooks/useRpc';
import {useSnackbar} from '@netx/core-components/Snackbar';
import {errors} from '../../../properties';
import {SearchAssetAttributesSchema} from '../../../schema/searchAssetAttributes';

const CHUNK_SIZE = 100;

// TODO: move service logic to an api folder
// REAL TODO: we need to ditch hypergrid and move all of this to our new patterns
export default function useGet() {
	const rpc = useRpc();
	const snackbar = useSnackbar();

	const get = useCallback(async () => {
		try {
			const search = Netx.cart.current.selection.createSearchObject();

			const getData = async (startIndex: number, count: number) => {
				return await rpc<{
					results: SearchAssetAttributesSchema[];
					size: number;
					startIndex: number;
				}>('searchAssetAttributes', [
					search.sortField,
					search.sortOrder,
					search.matchCriteria,
					search.elementTypes,
					search.elementSubType1s,
					search.elementSubType2s,
					search.elementValue1s,
					search.elementValue2s,
					search.elementValue3s,
					startIndex,
					count,
				]);
			};

			// DAM-24424: we are going to try and mitigate the 100s issue by breaking this in chunks for fetching
			const initialData = await getData(1, CHUNK_SIZE);
			const totalCount = initialData.size;
			if (totalCount <= CHUNK_SIZE) return initialData.results;
			while (initialData.results.length < totalCount) {
				const nextData = await getData(
					initialData.results.length + 1,
					CHUNK_SIZE,
				);
				initialData.results.push(...nextData.results);
			}
			return initialData.results;
		} catch (error: any) {
			// TODO: this is a hack until this is fully under react and not being fed via a backbone view
			if (error?.code === 524)
				dispatcher.trigger('app:remove:fsView:byId', 'TagPanelGridView');
			if (error?.code !== 524)
				dispatcher.trigger('notification', {
					module: 'app',
					title: i18n.t('i18n.error'),
					description:
						errors.read[error?.code as keyof (typeof errors)['update']] ||
						errors.read.default,
					type: 'danger',
				});
			// snackbar({
			// 	message:
			// 		errors.read[error?.code as keyof typeof errors['update']] ||
			// 		errors.read.default,
			// 	severity: 'error',
			// });
		}

		return [];
	}, []);

	return get;
}
